/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
// Function to add animation class on scroll
function addClassOnScroll(targetSelector, animateClass, threshold) {

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if (entry.isIntersecting) {

                entry.target.classList.add(animateClass);
                addStaggeredClass(entry.target);

            }

        });

    }, {
        threshold: threshold || 0.05, // Threshold of the element when scrolling to trigger the animation
    });

    const targetElements = document.querySelectorAll(targetSelector);
    targetElements.forEach((el) => {

        return observer.observe(el);

    });

}

// Function to add "js-staggered" class to elements with "js-stagger" class inside target element.
// Copy this function to your project if you need to add staggered or non-staggered animation to elements.
function addStaggeredClass(targetElement) {

    const staggeredElements = targetElement.querySelectorAll('.js-stagger');
    staggeredElements.forEach((staggeredEl, index) => {

        staggeredEl.classList.add('js-staggered');
        staggeredEl.style.transitionDelay = `${0.1 + index * 0.05}s`; // Start at half second second and adjust the delay as needed.

    });

}

function addRemoveClassOnScroll(elementSelector, className, scrollOffset) {

    const element = document.querySelector(elementSelector);
    let isClassAdded = false; // Track whether the class has been added

    if (!element) {

        // eslint-disable-next-line
        console.error(`Element with selector '${elementSelector}' not found.`);
        return;

    }

    // Function to handle the scroll event
    function handleScroll() {

        const scrollPosition = window.scrollY || window.pageYOffset;

        if (scrollPosition >= scrollOffset && !isClassAdded) {

            element.classList.add(className);
            isClassAdded = true;

        } else if (scrollPosition < scrollOffset && isClassAdded) {

            element.classList.remove(className);
            isClassAdded = false;

        }

    }

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Initial check in case the user starts at a scrolled position
    handleScroll();

}

// Call the main function
addClassOnScroll('.js-hidden', 'js-animate');
addClassOnScroll('.js-hidden.force-animate', 'js-animate', 0.01);
if (document.getElementsByClassName('js-hidden-scroll').length) {

    addRemoveClassOnScroll('.js-hidden-scroll', 'js-animate', 80); // Hero section specific for page actions

}
